import { EditorState, Plugin } from 'prosemirror-state';

import { RtPMPlugin } from '../../editor/types';

export class StateChangesPlugin implements RtPMPlugin {
  private plugin = new Plugin({
    view: () => ({
      update: view => this.onStateChanged(view.state),
    }),
  });

  constructor(private onStateChanged: (state: EditorState) => void) {}

  public getNativeEditorPlugins() {
    return [this.plugin];
  }
}
